import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as commonData from "../../../Common";
import Header from "../../../Header";
import { useSelector } from "react-redux";

const UserPage = (props) => {
  const userpro = useSelector((state) => console.log(state, 54651321));
  const url = commonData.commonData().apiUrl;
  const params = useParams();
  const [user, setUser] = useState({});

  useEffect(() => {
    const getencdata = commonData.getCommonData();

    try {
      axios
        .post(`${url}get-user-info`, {
          user_uuid: params.user_uuid,
        })
        .then((res) => {
          const { code, data } = res.data;

          if (code == 200) {
            setUser(data?.[0] || {});
          }
        });
    } catch (error) {
      console.log(error);
    }
  }, []);
  useEffect(() => {
    if (user.hasOwnProperty("profile_url") && user.profile_url) {
      window.location.href = user.profile_url;
    }
  }, [user]);
  return (
    <>
      <div className="mainContent-panel-wrap">
        <Header
          brecum_name={{ name: "", link: "list" }}
          brecum_page={"User Profile"}
        />
        <div className="page-content">
          <div className="container py-5 h-100">
            <div className="row d-flex justify-content-center align-items-center h-100">
              <div className="col col-md-9 col-lg-7 col-xl-5">
                <div className="card" style={{ borderRadius: "15px" }}>
                  <div className="card-body p-4">
                    <div className="d-flex text-black">
                      <div className="flex-shrink-0">
                        <img
                          src={user.profile_pic}
                          style={{ width: "100px", height: "100px" }}
                          className="rounded-circle rci"
                        />
                      </div>
                      <div className="flex-grow-1 ms-3">
                        <h5 className="mb-1">{user?.name}</h5>
                        <p className="mb-2 pb-1" style={{ color: "#2b2a2a" }}>
                          {user?.position}
                        </p>
                        <div
                          className="d-flex justify-content-start rounded-3 p-2 mb-2"
                          style={{ backgroundColor: "#efefef" }}
                        >
                          <div className="px-3">
                            <p className="small text-muted mb-1">Email</p>
                            <p className="mb-0">{user?.email}</p>
                          </div>
                        </div>
                        {/* <div className="d-flex pt-1">
                          <button
                            type="button"
                            className="btn btn-outline-primary me-1 flex-grow-1"
                          >
                            Chat
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary flex-grow-1"
                          >
                            Follow
                          </button>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserPage;
